/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown> }} Push_Meeting_TitleInputs */

const th_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} อยากคุยด้วย`)
};

const en_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} would like to meet`)
};

const ja_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} さんが打ち合わせを希望しています`)
};

const zh_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} 想与你会面`)
};

const es_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} quiere reunirse`)
};

const pt_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} quer conversar`)
};

const id_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} ingin bertemu dengan Anda`)
};

const fr_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} souhaite vous parler`)
};

const tl_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gustong makipagkita sa iyo ni ${i?.from}`)
};

const vi_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} muốn gặp bạn`)
};

const ko_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from}님이 만나고 싶어 합니다`)
};

const de_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} möchte sich mit dir treffen`)
};

const ru_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} хочет встретиться с вами`)
};

const tr_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} sizinle görüşmek istiyor`)
};

const it_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} vuole incontrarti`)
};

const pl_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} chce się z tobą spotkać`)
};

const uk_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} хоче зустрітися з вами`)
};

const hi_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} आपसे मिलना चाहते हैं`)
};

const ar_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يريد ${i?.from} لقاءك`)
};

const ms_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} ingin berjumpa anda`)
};

const bn_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} আপনার সঙ্গে দেখা করতে চান`)
};

const zh_tw2_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} 想與你會面`)
};

const zh_hk2_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} 想與你會面`)
};

const ur_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} آپ سے ملنا چاہتے ہیں`)
};

const fa_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} می‌خواهد شما را ببیند`)
};

const sw_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} anataka kukutana nawe`)
};

const nl_push_meeting_title = /** @type {(inputs: Push_Meeting_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} wil je spreken`)
};

/**
* | output |
* | --- |
* | "{from} would like to meet" |
*
* @param {Push_Meeting_TitleInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_meeting_title = /** @type {((inputs: Push_Meeting_TitleInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Meeting_TitleInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_meeting_title(inputs)
	if (locale === "ja") return ja_push_meeting_title(inputs)
	if (locale === "zh") return zh_push_meeting_title(inputs)
	if (locale === "es") return es_push_meeting_title(inputs)
	if (locale === "pt") return pt_push_meeting_title(inputs)
	if (locale === "id") return id_push_meeting_title(inputs)
	if (locale === "fr") return fr_push_meeting_title(inputs)
	if (locale === "tl") return tl_push_meeting_title(inputs)
	if (locale === "vi") return vi_push_meeting_title(inputs)
	if (locale === "ko") return ko_push_meeting_title(inputs)
	if (locale === "de") return de_push_meeting_title(inputs)
	if (locale === "ru") return ru_push_meeting_title(inputs)
	if (locale === "tr") return tr_push_meeting_title(inputs)
	if (locale === "it") return it_push_meeting_title(inputs)
	if (locale === "pl") return pl_push_meeting_title(inputs)
	if (locale === "uk") return uk_push_meeting_title(inputs)
	if (locale === "hi") return hi_push_meeting_title(inputs)
	if (locale === "ar") return ar_push_meeting_title(inputs)
	if (locale === "ms") return ms_push_meeting_title(inputs)
	if (locale === "bn") return bn_push_meeting_title(inputs)
	if (locale === "zh-TW") return zh_tw2_push_meeting_title(inputs)
	if (locale === "zh-HK") return zh_hk2_push_meeting_title(inputs)
	if (locale === "ur") return ur_push_meeting_title(inputs)
	if (locale === "fa") return fa_push_meeting_title(inputs)
	if (locale === "sw") return sw_push_meeting_title(inputs)
	if (locale === "nl") return nl_push_meeting_title(inputs)
	return en_push_meeting_title(inputs)
});